import { BufferGeometry } from 'three';

export const isBufferGeometry = (geom: any): geom is BufferGeometry =>
  geom && geom.isBufferGeometry;

export default isBufferGeometry;
